import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService, ZVOOVE_EMPLOYEE_ROLE } from '@zvoove-market/shared';
import { map, of, switchMap } from 'rxjs';

export const mandantSelectedGuard =
  (opts?: { allowBypassForZvoove: boolean }): CanActivateFn =>
  (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const auth = inject(AuthService);

    const refreshAvailableMandantsIfRequired =
      auth.$availableMandantsByCustomers() == null ? auth.refreshAvailableMandantsByCustomers() : of(auth.$availableMandantsByCustomers());

    return refreshAvailableMandantsIfRequired.pipe(
      switchMap((mandantsByCustomer) => {
        if (auth.$context().mandant) {
          return of(true);
        }

        if (mandantsByCustomer?.length === 1 && mandantsByCustomer[0].mandants.length === 1) {
          return auth.refreshLoginContext(mandantsByCustomer[0].mandants[0].zvooveMandantId).pipe(
            map(() => {
              const urltree = router.parseUrl(state.url);
              urltree.queryParams = {
                ...urltree.queryParams,
                mandantId: mandantsByCustomer[0].mandants[0].zvooveMandantId,
              };
              return urltree;
            })
          );
        }

        if (opts?.allowBypassForZvoove && auth.$context().globalRoles.includes(ZVOOVE_EMPLOYEE_ROLE)) {
          return of(true);
        }

        return of(router.createUrlTree(['mandant-select'], { queryParams: { returnUrl: state.url } }));
      })
    );
  };
